import Modal from './Modal'
import './InactivityWarningModal.scss'

/**
 * Modal displayed when user is about to be logged out due to inactivity.
 * Shows a countdown timer and allows user to extend their session.
 *
 * @param {boolean} isOpen - Whether the modal is visible
 * @param {number} secondsRemaining - Seconds until auto-logout
 * @param {function} onExtendSession - Callback to extend the session
 */
const InactivityWarningModal = ({ isOpen, secondsRemaining, onExtendSession }) => {
  const formatTime = (seconds) => {
    const mins = Math.floor(seconds / 60)
    const secs = seconds % 60
    if (mins > 0) {
      return `${mins}:${secs.toString().padStart(2, '0')}`
    }
    return `${secs} seconds`
  }

  return (
    <Modal
      isOpen={isOpen}
      onClose={onExtendSession}
      title="Session Timeout Warning"
      size="sm"
      showCloseButton={false}
    >
      <div className="inactivity-warning">
        <div className="inactivity-warning__icon">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="48"
            height="48"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <circle cx="12" cy="12" r="10" />
            <polyline points="12 6 12 12 16 14" />
          </svg>
        </div>

        <p className="inactivity-warning__message">
          Your session is about to expire due to inactivity.
        </p>

        <div className="inactivity-warning__countdown">
          <span className="inactivity-warning__time">{formatTime(secondsRemaining)}</span>
          <span className="inactivity-warning__label">until logout</span>
        </div>

        <p className="inactivity-warning__help">
          Click the button below to continue your session.
        </p>

        <button
          onClick={onExtendSession}
          className="inactivity-warning__button"
          autoFocus
        >
          Stay Logged In
        </button>
      </div>
    </Modal>
  )
}

export default InactivityWarningModal
